export const CLOSED_DROPDOWN = 0;
export const OPENED_DROPDOWN = "auto";
export const DROPDOWN_DURATION = 500;
